import React, { useRef, useState } from 'react'
import SbEditable from 'storyblok-react'
import Video from '../atoms/Video'
import Image from '../atoms/Image'

const FullscreenVideoBlock = ({ block }) => {
  const refVideo = useRef(null)

  const [isPlaying, setIsPlaying] = useState(false)

  const thumbnailPlay = () => {
    if (refVideo.current) {
      refVideo.current.play()
      setIsPlaying(true)
    }
  }

  return (
    <SbEditable content={block}>
      <section
        className={`fullscreen-video-block content-block-full-width ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <figure>
          <div className="figmedia">
            {block.sb_video?.filename?.length > 0 ? (
              <div className="fullscreen-video-block-sb-video">
                <video
                  ref={refVideo}
                  className="vid-fluid w-full"
                  src={block.sb_video.filename}
                  controls={block.sb_video_controls}
                  muted={block.sb_video_controls ? false : true}
                  autoPlay={block.sb_video_controls ? false : true}
                  loop={block.sb_video_controls ? false : true}
                />
                {block?.sb_video_thumbnail?.filename?.length > 0 && (
                  <div
                    className={`fullscreen-video-block-sb-video-thumbnail ${
                      isPlaying ? 'hidden' : ''
                    }`}
                    onClick={() => thumbnailPlay()}
                  >
                    <Image image={block?.sb_video_thumbnail} forceLoad={true} />
                  </div>
                )}
              </div>
            ) : (
              <Video video={block.video} _uid={block._uid} />
            )}
          </div>
          {block.caption?.length > 0 && (
            <figcaption>{block.caption}</figcaption>
          )}
        </figure>
      </section>
    </SbEditable>
  )
}

export default FullscreenVideoBlock
